import { render, staticRenderFns } from "./ProjectTopCardTargets.vue?vue&type=template&id=317ef446&scoped=true"
import script from "./ProjectTopCardTargets.vue?vue&type=script&lang=js"
export * from "./ProjectTopCardTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ef446",
  null
  
)

export default component.exports